import { ScrollArea } from '@/components/common/ScrollArea';
import Tooltip from '@/components/common/Tooltip';
import { getMenuList, isPathEk } from '@/utils/routes';
import { cn } from '@/utils/utils';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { WrapperSheetClose } from '../SheetMenu';
import { Button } from '@/components/common/Button';
import CollapseMenuButton from './CollapseMenuButton';
import { useStore } from '@/hooks/useStore';
import { ekDomain } from '@/configs/constants';

interface MenuProps {
    isOpen?: boolean,
    useSheetClose?: boolean,
    isMenuSheet?: boolean
}

export default function Menu({ isOpen, useSheetClose, isMenuSheet = false }: MenuProps) {
    // hooks
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);

    // store
    const {
        authStore: { profileGas, profileEk, logout },
        clearAllStore
    } = useStore();

    // function
    const getRoleCodeUser = (isEk: boolean) => {
        if (isEk) {
            if (!profileEk?.roleCode) {
                logout();
                return '';
            }
            return profileEk?.roleCode;
        } else {
            if (!profileGas?.roleCode) {
                logout();
                return '';
            }
            return profileGas?.roleCode;
        }
    };

    const menuList = getMenuList(pathname, getRoleCodeUser(isEk));

    return (
        <nav className={cn('h-full w-full px-5 flex flex-col justify-between text-[#fff]', !isMenuSheet && 'mt-4')}>
            <ScrollArea className='[&>div>div[style]]:!block -mr-[calc(1.25rem+1px)] pr-5'>
                <ul className={cn(
                    'flex flex-col items-start space-y-1',
                    isMenuSheet ? 'max-h-[calc(100vh-36px-32px-72px)]' : 'max-h-[calc(100vh-36px-32px-30px)]'
                )}
                >
                    {menuList.map(({ groupLabel, menus }, index) => (
                        <li
                            className={cn('w-full', groupLabel ? 'pt-5' : '')}
                            key={index}
                        >
                            {
                                menus.map(({ href, label, icon: Icon, active, submenus }, index) => (
                                    submenus.length === 0 ?
                                        (
                                            <div className='w-full' key={index}>
                                                <Tooltip
                                                    content={isOpen === false && t(label)}
                                                    triggerAsChild={true}
                                                    side='right'
                                                >
                                                    <WrapperSheetClose useSheetClose={useSheetClose}>
                                                        <Button
                                                            variant={active ? 'activeMenu' : 'ghostMenu'}
                                                            className='w-full justify-start h-10 mb-1'
                                                            asChild
                                                        >
                                                            <Link
                                                                to={isEk ? `/${ekDomain}${href}` : href}
                                                                className={cn(isOpen === false && 'flex justify-center')}
                                                                onClick={() => {
                                                                    !active && clearAllStore();
                                                                }}
                                                            >
                                                                <span
                                                                    className={cn(isOpen === false ? '' : 'mr-4')}
                                                                >
                                                                    <Icon size={18} />
                                                                </span>
                                                                <p
                                                                    className={cn(
                                                                        'max-w-[200px] truncate',
                                                                        isOpen === false ?
                                                                            '-translate-x-96 opacity-0 hidden' :
                                                                            'translate-x-0 opacity-100'
                                                                    )}
                                                                >
                                                                    {t(label)}
                                                                </p>
                                                            </Link>
                                                        </Button>
                                                    </WrapperSheetClose>
                                                </Tooltip>
                                            </div>
                                        ) :
                                        (
                                            <div className='w-full' key={index}>
                                                <CollapseMenuButton
                                                    icon={Icon}
                                                    label={label}
                                                    active={active}
                                                    submenus={submenus}
                                                    isOpen={isOpen}
                                                    useSheetClose={useSheetClose}
                                                />
                                            </div>
                                        )
                                ))
                            }
                        </li>
                    ))}
                </ul>
            </ScrollArea>
        </nav>
    );
}
